import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import sadminapi from '../api/sadminapi';
import loginapi from '../api/login';

function AddNewUser({ accessToken, setAccessToken, setRefreshFailed,pageOptions=[] }) {
  const navigate = useNavigate();
  const handleGoBack = () => navigate(`/manageuser`);

  // -----------------------------
  // FORM STATE
  // -----------------------------
  const [displayName, setDisplayName] = useState("");

  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [usernameAvailable, setUsernameAvailable] = useState(null);

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [allowedPages, setAllowedPages] = useState([]);
  const [status, setStatus] = useState(true);


  const [checking,setChecking]=useState(false);
  const [saving,setSaving]=useState(false);
  
  // -----------------------------
  // VALIDATE USERNAME
  // -----------------------------
  const handleUsernameChange = (e) => {
    let v = e.target.value.toLowerCase();
    setUsername(v);
    setUsernameAvailable(null);

    if (v.length < 3 || v.length > 20) {
      setUsernameError("Username must be 3–20 characters.");
    } else if (!/^[a-z_]+$/.test(v)) {
      setUsernameError("Only letters and underscore allowed.");
    } else {
      setUsernameError("");
    }
  };

 

  // -----------------------------
  // PASSWORD VALIDATION
  // -----------------------------


    const handlePasswordChange = (e) => {
  const v = e.target.value;
  setPassword(v);

  // Strong password regex:
  // At least 1 lowercase, 1 uppercase, 1 digit, 1 symbol, min length 6
  const strongPassRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{6,}$/;

  if (v.trim().length === 0) {
    setPasswordError("");
    return;
  }

  if (v.length < 6) {
    setPasswordError("Password must be at least 6 characters.");
    return;
  }

  if (!strongPassRegex.test(v)) {
    setPasswordError(
      "Must contain 1 lowercase, 1 uppercase, 1 number, 1 symbol."
    );
    return;
  }

  setPasswordError("");
};


  // -----------------------------
  // HANDLE PAGE SELECTION
  // -----------------------------
  const togglePage = (p) => {
    setAllowedPages((prev) =>
      prev.includes(p) ? prev.filter((x) => x !== p) : [...prev, p]
    );
  };

  // -----------------------------
  // ENABLE SAVE ONLY IF VALID
  // -----------------------------
  const saveEnabled =
    displayName.trim() !== "" &&
    username &&
    usernameError === "" &&
    usernameAvailable === true &&
    password &&
    passwordError === "";

  // -----------------------------
  // SAVE ACTION
  // -----------------------------
  const onSave = async () => {
   
    const txUser={
      displayName,
      username,
      password,
      allowed_pages: allowedPages,
      status: status ? "active" : "inactive",
    };

    setSaving(true);
            try{
              const response= await sadminapi.post('/saveUser',{txUser},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              alert(response.data.status);
              if(response.data.status==='created'){
                navigate(`/manageuser`);
              }
                //setUsernameAvailable(response.data.isAvailbale);
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                try{       
                 const response= await sadminapi.post('/saveUser',{txUser},{headers:{'Authorization':`Bearer ${nat}`}});    
                 alert(response.data.status);
                 if(response.data.status==='created'){
                navigate(`/manageuser`);
              }
                //setUsernameAvailable(response.data.isAvailbale);
                 }
                 catch(err)
                 {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  alert('unusual error newposts.js');
                 }
              }
              catch(err)
              {
                alert('failed');
              }
      
            }
            finally
            {
              setSaving(false);
            }
  };

   // -----------------------------
  // CHECK USERNAME AVAILABILITY (dummy)
  // -----------------------------
  const checkAvailability = async () => {
    setChecking(true);
            try{
              const response= await sadminapi.post('/checkAvailAbleUser',{username},{headers:{'Authorization':`Bearer ${accessToken}`}});    
              //alert(response.data.isAvailbale);
                setUsernameAvailable(response.data.isAvailbale);
            }
            catch(err)
            {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                try{       
                 const response= await sadminapi.post('/checkAvailAbleUser',{username},{headers:{'Authorization':`Bearer ${nat}`}});    
                 // alert(response.data.isAvailbale);
                setUsernameAvailable(response.data.isAvailbale);
                 }
                 catch(err)
                 {
                  if( err.response.status===403)
                    {
                      navigate(`/accessdenied`); 
                    }
                  alert('unusual error newposts.js');
                 }
              }
              catch(err)
              {
                alert('failed');
              }
      
            }
            finally
            {
              setChecking(false);
            }
  };

  return (
    <main className="w-full">
      <div className="w-full bg-red-100 relative py-1">
        <button
          onClick={handleGoBack}
          className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition text-xs"
        >
          BACK
        </button>

        <h1 className="text-2xl text-gray-400 text-center">ADD NEW USERS</h1>
        <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>
      </div>

      <div className="flex flex-col items-center justify-center w-full p-3">
        <form className="w-full max-w-md bg-white shadow-md rounded-lg p-4">

          {/* DISPLAY NAME */}
          <label className="block font-semibold text-gray-600 text-sm mb-1">
            Display Name
          </label>
          <input
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="w-full p-2 border rounded-md text-sm"
            placeholder="User's name or branch"
          />
          {displayName.trim() === "" && (
            <p className="text-red-500 text-xs mt-1">Display name is required.</p>
          )}

          {/* USERNAME */}
          <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
            Username
          </label>

          <div className="flex gap-2">
            <input
              value={username}
              onChange={handleUsernameChange}
              maxLength={20}
              className="w-full p-2 border rounded-md text-sm"
              placeholder="letters + underscore only"
            />

            <button
              type="button"
              onClick={checkAvailability}
              disabled={usernameError !== "" || username.length < 3}
              className={`px-2 py-2 rounded-md text-xs ${
                usernameError || username.length < 3
                  ? "bg-gray-300 text-gray-600"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Check
            </button>
          </div>

          {usernameError && (
            <p className="text-red-500 text-xs mt-1">{usernameError}</p>
          )}

{false && (alert(usernameAvailable))}
          {usernameAvailable === true && (
            <p className="text-green-600 text-xs mt-1">Username available ✓</p>
          )}
          {usernameAvailable === false && (
            <p className="text-red-500 text-xs mt-1">Username already exists ✗</p>
          )}

          {/* PASSWORD */}
          <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
            Password
          </label>
          <input
            type="text"
            value={password}
            onChange={handlePasswordChange}
            className="w-full p-2 border rounded-md text-sm"
            placeholder="min 6 chrs,lowercase, uppercase,number,symbol."
          />
          {passwordError && (
            <p className="text-red-500 text-xs mt-1">{passwordError}</p>
          )}

          {/* STATUS */}
          <div className="mt-4 flex items-center gap-2 ">
            <input
              type="checkbox"
              checked={status}
              onChange={() => setStatus(!status)}
              className="scale-150"
            />
            <span className="text-sm text-gray-600">
              Active (uncheck → inactive)
            </span>
          </div>

          {/* ALLOWED PAGES */}
          <label className="block font-semibold text-gray-600 text-sm mt-4 mb-1">
            Allowed Pages
          </label>

          <div className="grid grid-cols-1 gap-3  overflow-y-auto border p-2 rounded-md">
            {pageOptions.map((p) => (
              <label key={p} className="flex items-center gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={allowedPages.includes(p)}
                  onChange={() => togglePage(p)}
                  className="scale-150"
                />
                {p}
              </label>
            ))}
          </div>

          {/* SAVE BUTTON */}
          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={onSave}
              disabled={!saveEnabled}
              className={`px-4 py-2 rounded-md text-xs ${
                saveEnabled
                  ? "bg-blue-500 text-white hover:bg-blue-600"
                  : "bg-gray-300 text-gray-600"
              }`}
            >
              SAVE
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}

export default AddNewUser;
